module.exports = __webpack_public_path__ + "img/gauvain.166f1560.jpg";